// extracted by mini-css-extract-plugin
module.exports = {"wkButton":"style_wkButton__vw6Jk","primary":"style_primary__BL0_Q","disabled":"style_disabled__f0rO6"};